import { render, staticRenderFns } from "./AddToWishList.vue?vue&type=template&id=4b0378ad&scoped=true"
import script from "./AddToWishList.vue?vue&type=script&lang=js"
export * from "./AddToWishList.vue?vue&type=script&lang=js"
import style0 from "./AddToWishList.vue?vue&type=style&index=0&id=4b0378ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0378ad",
  null
  
)

export default component.exports